import React from 'react';
import classNames from 'classnames';

const TabHeader = ({tabs = [], handleClick = () => {}, positionTab = 0}) => {

    return (
        <ul className="labels">
        {tabs.map((child, index) => {
            // const activeClass = this.state.selected === index ? 'active' : '';
            return (
                <li  onClick={handleClick.bind(this, index)} className={classNames({ 'active-white': (positionTab === index), 'normal-tab': true })} key={`tab-${index}`}>
                    <a>
                        <span className="inline">{child.props.label}</span>
                    </a>
                </li>
                );
            })
            }
        </ul>
    )      
};

export default TabHeader;



// WEBPACK FOOTER //
// ./src/components/shared/tabs/tab-header.js